import { useState } from "react";
import { createUser } from "../../../api/admin/userManager";
import {
  swalSuccess,
  swalError,
  swalWarning,
} from "../../../utils/swalAlert.js";

import "../../../styles/AdminPanel/AddUser.css";

export default function AddUser() {
  const [form, setForm] = useState({
    phone_number: "",
    first_name: "",
    last_name: "",
    role: "user",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const saveUser = async () => {
    if (!form.phone_number) {
      return swalWarning({ title: "شماره موبایل الزامی است" });
    }

    setLoading(true);
    try {
      await createUser(form);

      swalSuccess({ title: "کاربر با موفقیت ایجاد شد!" });

      setForm({
        phone_number: "",
        first_name: "",
        last_name: "",
        role: "user",
      });
    } catch (err) {
      const errorMsg =
        err.error || (typeof err === "string" ? err : "خطا در ایجاد کاربر");

      swalError({ title: "خطا", text: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-content">
      <h2>تعریف کاربر جدید</h2>

      <div className="adduser-form-container">
        <div className="adduser-form">
          <div className="form-group">
            <label>شماره موبایل</label>
            <input
              name="phone_number"
              placeholder="0912..."
              value={form.phone_number}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>نام</label>
            <input
              name="first_name"
              value={form.first_name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>نام خانوادگی</label>
            <input
              name="last_name"
              value={form.last_name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>نقش</label>
            <select name="role" value={form.role} onChange={handleChange}>
              <option value="user">کاربر عادی</option>
              <option value="support">پشتیبان</option>
              {/* <option value="marketer">بازاریاب</option> */}
              <option value="admin">ادمین</option>
            </select>
          </div>

          <div className="form-submit">
            <button onClick={saveUser} disabled={loading} className="save-btn">
              {loading ? "در حال ذخیره..." : "ذخیره کاربر"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
